const styles = theme => ({
  root: {
    backgroundColor: '#FFF',
    borderRadius: '2px',
    boxShadow:
      '0 1px 1px 0 rgba(12,31,44,0.12), 0 2px 1px -1px rgba(0,0,0,0.12), 0 1px 3px 0 rgba(12,31,44,0.2)',
    padding: theme.spacing.unit * 4,
    width: '100%',
    marginBottom: '10px'
  },
  headerSection: {
    flex: 1,
    paddingBottom: theme.spacing.unit * 4,
    marginBottom: theme.spacing.unit * 4,
    borderBottom: '1px solid rgba(0,0,0,0.12)'
  },
  bodySection: {
    display: 'flex',
    flex: 1
  },
  sidebarInfo: {
    paddingRight: theme.spacing.unit * 4,
    width: '22.169%'
  },
  contentDetails: {
    borderLeft: '1px solid rgba(0,0,0,0.12)',
    paddingLeft: theme.spacing.unit * 4,
    paddingRight: theme.spacing.unit * 4,
    width: '53.616%'
  },
  sidebarActivity: {
    borderLeft: '1px solid rgba(0,0,0,0.12)',
    paddingLeft: theme.spacing.unit * 4,
    width: '24.213%'
  },
  contentDividerInt: {
    paddingBottom: theme.spacing.unit * 4,
    marginBottom: theme.spacing.unit * 3.5,
    borderBottom: '1px solid rgba(0,0,0,0.12)',
    '&:last-child': {
      marginBottom: 0,
      borderBottom: 0
    }
  },
  shipmentContentTitle: {
    marginBottom: theme.spacing.unit * 2
  },
  noMarginBottom: {
    marginBottom: 0
  },
  hideSection: {
    display: 'none'
  },
  editButton: {
    paddingRight: '0 !important',
    height: '28px !important'
  },
  buttonRoot: {
    '&:hover': {
      //you want this to be the same as the backgroundColor above
      backgroundColor: '#fff'
    }
  },
  toolbarRoot: {
    alignItems: 'center',
    display: 'flex',
    marginBottom: theme.spacing.unit * 5
  }
});

export default styles;
